// extracted by mini-css-extract-plugin
export default {"wrapper":"Audios_wrapper__jKcjy","list":"Audios_list__n3EBL","row":"Audios_row__Nv0xd"};